import ACTIONS from '../actionTypes/release'

const initialState = {
	release: null,
	isFetchingCurrentRelease: false,
	isCreatingRelease: false,
	releaseList: [],
	isFetchingReleaseList: false,
	errorFetchingReleaseList: false,
	isUpdatingRelease: false,
	errorUpdatingRelease: false,
	releasesForApp: [],
	isFetchingReleasesForApp: false,
	errorFetchingReleasesForApp: false,
	isSendingForApproval: false,
	errorSendingForApproval: false,
	isCancellingApproval: false,
	errorCancellingApproval: false,
	isCloningRelease:false
}

const release = (state = initialState, action) => {
	switch (action.type) {
		// createRelease
		case ACTIONS.START_CREATE_RELEASE:
			return {
				...state,
				isCreatingRelease: true,
			}
		case ACTIONS.CREATE_RELEASE_SUCCESS:
			return {
				...state,
				isCreatingRelease: false,
				release: action.payload,
			}
		case ACTIONS.CREATE_RELEASE_FAILED:
			return {
				...state,
				isCreatingRelease: false
			}

		// getReleaseList
		case ACTIONS.START_GET_RELEASE_LIST:
			return {
				...state,
				isFetchingReleaseList: true,
			}
		case ACTIONS.GET_RELEASE_LIST_SUCCESS:
			return {
				...state,
				isFetchingReleaseList: false,
				errorFetchingReleaseList: false,
				releaseList: action.payload,
			}
		case ACTIONS.GET_RELEASE_LIST_FAILED:
			return {
				...state,
				isFetchingReleaseList: false,
				errorFetchingReleaseList: true,
				releaseList: null,
			}

		// getReleaseById
		case ACTIONS.START_GET_RELEASE_BY_ID:
			return {
				...state,
				isFetchingCurrentRelease: true
			}
		case ACTIONS.GET_RELEASE_BY_ID_SUCCESS:
			const release = action.payload
			return {
				...state,
				isFetchingCurrentRelease: false,
				release
			}
		case ACTIONS.GET_RELEASE_BY_ID_FAILED:
			return {
				...state,
				isFetchingCurrentRelease: false,
				release: null,
			}

		// getReleasesForApplication
		case ACTIONS.START_GET_RELEASE_BY_APP_ID:
			return {
				...state,
				isFetchingReleasesForApp: true
			}
		case ACTIONS.GET_RELEASE_BY_APP_ID_SUCCESS:
			return {
				...state,
				isFetchingReleasesForApp: false,
				errorFetchingReleasesForApp: false,
				releasesForApp: action.payload,
			}
		case ACTIONS.GET_RELEASE_BY_APP_ID_FAILED:
			return {
				...state,
				isFetchingReleasesForApp: false,
				errorFetchingReleasesForApp: true
			}

		// updateRelease
		case ACTIONS.START_UPDATE_RELEASE:
			return {
				...state,
				isUpdatingRelease: true
			}
		case ACTIONS.UPDATE_RELEASE_SUCCESS:
			return {
				...state,
				isUpdatingRelease: false,
				errorUpdatingRelease: false,
				release: {
					...state.release,
					...action.payload,
					data: JSON.stringify(action.payload?.application)
				}
			}
		case ACTIONS.UPDATE_RELEASE_FAILED:
			return {
				...state,
				isUpdatingRelease: false,
				errorUpdatingRelease: true
			}

		// sendForApproval
		case ACTIONS.START_SEND_FOR_APPROVAL:
			return {
				...state,
				isSendingForApproval: true
			}
		case ACTIONS.SEND_FOR_APPROVAL_SUCCESS:
			return {
				...state,
				isSendingForApproval: false,
				errorSendingForApproval: false,
				release: {
					...state.release,
					status: action.payload?.status,
					updatedDate: action.payload?.updatedDate
				}
			}
		case ACTIONS.SEND_FOR_APPROVAL_FAILED:
			return {
				...state,
				isSendingForApproval: false,
				errorSendingForApproval: true
			}

		// cancelApproval
		case ACTIONS.START_CANCEL_APPROVAL:
			return {
				...state,
				isCancellingApproval: true
			}
		case ACTIONS.CANCEL_APPROVAL_SUCCESS:
			return {
				...state,
				isCancellingApproval: false,
				errorCancellingApproval: false,
				release: {
					...state.release,
					status: action.payload?.status,
					updatedDate: action.payload?.updatedDate
				}
			}
		case ACTIONS.CANCEL_APPROVAL_FAILED:
			return {
				...state,
				isCancellingApproval: false,
				errorCancellingApproval: true
			}

		// clone release
		case ACTIONS.START_CLONE_RELEASE:
			return {
				...state,
				isCloningRelease: true,
			}
		case ACTIONS.CLONE_RELEASE_SUCCESS:
			return {
				...state,
				isCloningRelease: false,
				release: action.payload,
			}
		case ACTIONS.CLONE_RELEASE_FAILED:
			return {
				...state,
				isCloningRelease: false
			}
		// default
		default:
			return state
	}
}

export default release